import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "14",
  fill: "none",
  viewBox: "0 0 12 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M6 3.6a4.4 4.4 0 1 0 0 8.8 4.4 4.4 0 0 0 0-8.8M0 8a6 6 0 1 1 12 0A6 6 0 0 1 0 8",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M.234 2.234a.8.8 0 0 1 1.131 0l1.2 1.2a.8.8 0 0 1-1.13 1.132l-1.2-1.2a.8.8 0 0 1 0-1.132m9.2 2.332a.8.8 0 0 0 1.131 0l1.2-1.2a.8.8 0 0 0-1.13-1.132l-1.2 1.2a.8.8 0 0 0 0 1.132M8.624 5.9A.8.8 0 0 1 8.5 7.025l-2 1.6a.8.8 0 1 1-1-1.25l2-1.6a.8.8 0 0 1 1.125.125M5.2 2.4V.8h1.6v1.6z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-rule": "evenodd",
      d: "M4 .8a.8.8 0 0 1 .8-.8h2.4a.8.8 0 0 1 0 1.6H4.8A.8.8 0 0 1 4 .8",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }